import { ACTIVITY_FIELDS, ActivityField, IExternalAgent } from "./IExternalAgent";
import styles from "./styles.module.css";

interface IProps {
  agent: IExternalAgent;
  handleChange: (field: ActivityField, value: boolean) => void;
}

const LABELS: { [K in ActivityField]: string } = {
  booking: "Booking",
  support: "Support",
  complains: "Complains",
  membership: "Membership",
  voicemail: "Voicemail",
  marketing: "Marketing",
  dsr: "DSR",
  reception: "Reception",
};

/**
 * The task types this agent may be offered.
 *
 * The list is derived from ACTIVITY_FIELDS rather than repeated here, so it cannot drift from
 * the payload or from the server's own field list. Labels were previously produced by
 * capitalising the column name, which rendered "Dsr" for what the rest of the call center
 * calls DSR.
 */
const Activities = ({ agent, handleChange }: IProps) => {
  return (
    <div className={styles.Panel}>
      <div className={styles.PanelTitle}>Activities</div>
      <hr className={styles.PanelRule} />
      {ACTIVITY_FIELDS.map((field) => (
        <div key={field}>
          <label className={styles.CheckLabel}>
            <input
              type="checkbox"
              // Always a boolean — emptyExternalAgent() seeds every flag false, so this is
              // never the `undefined` that used to leave the box uncontrolled and unchecked
              // regardless of what the record said.
              checked={agent[field]}
              onChange={(e) => handleChange(field, e.target.checked)}
            />
            <span>{LABELS[field]}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default Activities;
